import type { EventListPageTypeString } from '~/composables/types/strapiEventListPage'
import { EventListPageType } from '~/composables/types/strapiEventListPage'

export const useEventListPageType = (): EventListPageTypeString => {
  const route = useRoute()
  const pathSegments = route.path.split('/').filter(Boolean)
  const firstSegmentAfterLocale = pathSegments[1]

  if (firstSegmentAfterLocale === 'teamevent')
    return EventListPageType.TEAMEVENT
  if (firstSegmentAfterLocale === 't') return EventListPageType.GENERAL
  if (firstSegmentAfterLocale === 'c') return EventListPageType.CATEGORY
  if (route.params.location && route.params.category)
    return EventListPageType.CITY_CATEGORY
  if (route.params.location) return EventListPageType.CITY

  throw new Error(`Cannot infer event list page type from route: ${route.path}`)
}
